export const ganttLabelStyleTypes = {
    CLASSIC: "classic",
    COMPACT: "compact",
  };
  